<script lang="ts" setup>
import { ref, computed, watch, toRefs, inject } from 'vue'
import Layout from "@/Shared/Layout.vue";
import Cms from "@/components/Cms";
// import { route } from "ziggy-js";
import { Link, router } from "@inertiajs/vue3";
// import { registeredComponents } from "@root/customer-service-header.ts";
import { getBuilderComponents } from "@root/builder-components.ts";
import { v4 as uuidv4} from 'uuid';
import { onClickOutside } from "@vueuse/core";
let route = inject('route');
let currentRoute = computed({
    get(){
        return routeRef.value;
    },
    set(newVal){
        routeRef.value = newVal;
    }
});

let currentLink = computed(()=>{
    return computedLinks.value.find((link)=>{
        return link.current;
    }) ?? {
        name: 'Customer Care'
    }
})

let routeRef = ref(route().current());

let currentRouteUrl = computed(()=>{
    if(typeof window == 'undefined'){
        return '';
    }
    return window.location.href.replace(window.origin, '');
}) 

let props = defineProps({
    currentView: {
        type: String,
        default: 'index'
    },
    links: {
        type: Array,
        default(){
            return [
                {   
                    id: uuidv4(),
                    name: 'Contact Us',
                    route: 'customer-service.index',
                    value: 'index',
                    current: false,
                    mobileOnly: false,
                    classes: {},
                    ariaLabel: 'Contact Us'
                },
                // faqs
                {
                    id: uuidv4(),
                    name: "FAQs",
                    route: "customer-service.faqs",
                    value: 'faqs',
                    current: false,
                    mobileOnly: false,
                    classes: {},
                    ariaLabel: 'FAQs'
                },
                {
                    id: uuidv4(),
                    name: "Order Details / Status",
                    route: "customer-service.lookup.show",
                    value: 'order.lookup.show',
                    current: false,
                    mobileOnly: false,
                },
                {
                    id: uuidv4(),
                    name: "Retail Locator",
                    route: "retail.locator.search",
                    value: 'retail.locator.search',
                    current: false,
                    mobileOnly: false,
                    ariaLabel: 'Retail Locator'
                }
            ]
        }
    }
})

let builderLinks = computed(()=>{
    return builderData.value.map((item)=>{
        return {
            id: uuidv4(),
            name: item.pageName,
            route: 'customer-service.cms',
            params: [item.pageUrl.replace("/customer-service/cms/", '')],
            value: {
                route: 'customer-service.cms',
                params: [item.pageUrl.replace("/customer-service/cms/", '')]
            },
            current: false,
            mobileOnly: false,
            classes: {},
            ariaLabel: item.pageName
        }
    }).sort((a, b)=>{
        return a.sort - b.sort;
    })
})


let { links } = toRefs(props);
let computedLinks = computed(()=>{


    let arr = [
        ...links.value,
        ...builderLinks.value
    ].map((link)=>{
        let current = false;

        if(typeof(link.value) == 'object'){
            current = link.value.params.includes(props.currentView);
        }
        else{
            current = props.currentView == link.value;
        }
        return {
            ...link,
            classes: {
                'current': current
            },
        }
    })

    return arr;
})

let desktopLinks = computed(()=>{
    return computedLinks.value.filter((link)=>{
        return !link.mobileOnly;
    })
})

watch(routeRef, (newVal)=>{
    router.visit(newVal, {
        preserveScroll: true,
    });
})

function setParams(link){
    if(typeof(link.value) == 'object'){
        return link.value.params;
    }
    return [];
}

let details = ref(null);

function closeDetails(){
    details.value?.removeAttribute?.('open');
}
onClickOutside(details, closeDetails);


let searchParams = computed(()=>{
    return {
        "data.pageType.$eq": "Customer Service",
        "data.showInNav.$eq": true
    }
})

let builderData = ref([]);
</script>
<template>
    <Layout>
        <Cms model="customer-service-header" :url="currentRouteUrl" driver="builder" is-section :components="getBuilderComponents()"/>
        <Cms v-show="false" v-model="builderData" driver="builder" model="content-section" :readable-fields="['pageName', 'pageUrl']" is-data :search-params="searchParams" />
        <div class="customer_service">
            <div class="customer_service-sidebar bg-rothcoCream">
                <div class="customer_service-menu">
                    <div class="aside-menu-desktop">
                        <div class="aside-menu-content">
                            <div class="account-menu-desktop">
                                <div class="navlinks">
                                    <Link 
                                        v-for="(link, index) of desktopLinks"
                                        :href="route(link.route, setParams(link))"
                                        :class="link.classes"
                                        :key="link.id"
                                        preserve-scroll
                                        :aria-label="link.ariaLabel"
                                        role="link"
                                    >{{ link.name }}</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="nav-selector bg-rothcoCream">
                    <details ref="details" class="nav-selector__details">
                        <summary class="nav-selector__title">
                            {{ currentLink.name }}
                        </summary>
                        <div class="nav-selector__content">
                            <ul class="">
                                <li v-for="(link, index) of computedLinks" :key="index">
                                    <Link 
                                        :href="route(link.route, setParams(link))"
                                        :class="link.classes"
                                        :aria-label="link.ariaLabel"
                                        :onSuccess="closeDetails"
                                        role="link"
                                    >{{ link.name }}</Link>
                                </li>
                            </ul>
                        </div>
                    </details>
                </div>
            </div>

            <div class="customer_service-content" style="width: 90%">
                <slot></slot>
            </div>
        </div>
    </Layout>
</template>